import { Card } from "../../../components/card.component";
import { InsuranceListOnReportingTab } from "../../../components/insuranceTableOnReportingTab.component";
import { TaskListOnReportingTab } from "../../../components/taskListOnReportingTab.component";
import { useAppSelector } from "../../../core/redux";
import { CaregiversReport } from "../../../components/caregiversReportOnReportingTab.component";
import { ReferralsReport } from "../../../components/referralsReport";
import { MissingInvoiceReport } from "../../../components/missingInvoiceReport";
import { InvoiceReport } from "../../../components/invoiceReport";

export function PageReport(): JSX.Element {
  const { userRole } = useAppSelector((state) => state.auth);

  return (
    <>
      {userRole === "Admin" ? (
        <>
          <section className="py-1 ">
            <Card
              header={
                <div className="row align-items-center  justify-content-between">
                  <div className="col-md-8 col-12 content-box-title">
                    <div>
                      <p className="text-capitalize my-1 text-green-200">
                        Reports
                      </p>
                    </div>
                    <div className="collapse-icon"></div>
                  </div>
                </div>
              }
            >
              <div className="row">
                <div className="col mb-2">
                  <MissingInvoiceReport />
                </div>
                <div className="col mb-2">
                  <InvoiceReport />
                </div>
              </div>
              <div className="row">
                <div className="col mb-2">
                  <ReferralsReport />
                </div>
                <div className="col mb-2">
                  <CaregiversReport />
                </div>
              </div>
              <div className="row">
                <div className="col col-md-6">
                  <TaskListOnReportingTab />
                </div>
              </div>
            </Card>
          </section>
        </>
      ) : (
        <Card
          header={
            <div className="row align-items-center  justify-content-between">
              <div className="col-md-8 col-12 content-box-title">
                <div>
                  <p className="text-capitalize my-1 text-green-200">Reports</p>
                </div>
                <div className="collapse-icon"></div>
              </div>
            </div>
          }
        >
          <div className="row">
            <div className="col-md-12 mb-2">
              <InsuranceListOnReportingTab />
            </div>
          </div>
        </Card>
      )}
    </>
  );
}
